package com.shadowings.gero.util

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.ImageBitmap
import kotlinx.browser.window

@Composable
actual fun rememberShareManager(): (text: String, image: ImageBitmap?, title: String) -> Unit {
    return { text, _, _ ->
        runCatching {
            window.navigator.clipboard.writeText(text)
        }
    }
}
